(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FFAF-venue-map-hero"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anaconda-voucher-hero"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hard-shandy-2026-hero"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-FSL-LongNeck-2026"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-events-cal"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ffaf-2026"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ffaf"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-partner-newsletter-signup"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-story"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-template"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-where-to-buy"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-clear';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onpacker-ii-2026-hero"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-beer"]) return;
  try {
    

  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-staff"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  var root = document.getElementsByTagName( 'html' )[0];

  root.className += ' ' + 'ui-bg';

  } catch(e) { console.error(e); }
})();
})();
